import React, { useState } from 'react';

import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { ClassInfo } from '../../context/types';
import Modal, { ModalSize } from '../Modal';
import SessionAddForm from './SessionAddForm';
import { StudentGroupRecord } from '../../../../models/types';

const StyledButton = styled(Button)`
    white-space: nowrap;
    margin-left: 1rem;
`;

export interface SessionAddModalProps {
    classInfo: ClassInfo,
    classUuid: string,
    fetchSessions: () => void;
    classGroups?: StudentGroupRecord[] | undefined;
    classSessionGroupUuid?: string;
    label?: string;
}

const AddSessions: React.FC<SessionAddModalProps> = ({ classInfo, classUuid, fetchSessions, classSessionGroupUuid, label, classGroups }) => {
    const [open, setOpen] = useState(false);
    const { t } = useTranslation('attendance');

    const handleMenuClose = () => {
        setOpen(false);
    };

    const openMenu = () => {
        setOpen(true);
    };

    const onFinish = () => {
        fetchSessions();
        handleMenuClose();
    };

    return (
        <>
            <StyledButton
                id="add-new-class-dates-btn"
                variant="outlined"
                color="inherit"
                size="small"
                onClick={() => openMenu()}
            >
                {t('add-new-class-dates')}
            </StyledButton>
            <Modal size={ModalSize.Large} isOpen={open} onClose={handleMenuClose}>
                <SessionAddForm onFinish={onFinish} onCancel={handleMenuClose} classInfo={classInfo} classUuid={classUuid} classSessionGroupUuid={classSessionGroupUuid} label={label} classGroups={classGroups} />
            </Modal>
        </>
    );
};

export default AddSessions;
